import { useHasActiveWaterMeter } from '@/hooks/usage/useHasActiveWaterMeter';
import { useIsOnMeasuredTariff } from '@/hooks/usage/useIsOnMeasuredTariff';
import { useShouldShowSmartChart } from '@/hooks/usage/useShouldShowSmartChart';

export const useShouldShowUsageTab = () => {
  const {
    isLoading: isLoadingHasActiveWaterMeter,
    isError: isErrorHasActiveWaterMeter,
    data: activeWaterMeterCount,
  } = useHasActiveWaterMeter();

  const {
    isLoading: isLoadingIsMeasured,
    isError: isErrorIsMeasured,
    data: isMeasured,
  } = useIsOnMeasuredTariff();

  const {
    isSmart,
    isLoading: isLoadingSmartCheck,
    isError: isErrorSmartCheck,
  } = useShouldShowSmartChart();

  const isLoading =
    isLoadingHasActiveWaterMeter || isLoadingIsMeasured || isLoadingSmartCheck;
  const isError =
    isErrorHasActiveWaterMeter || isErrorIsMeasured || isErrorSmartCheck;

  const smartCheckMeter = isSmart && !isMeasured;
  const isSingleMeter = activeWaterMeterCount === 1;

  const displayUsageLink =
    (isSingleMeter && isMeasured) || (isSingleMeter && smartCheckMeter);

  return {
    isLoading,
    isError,
    displayUsageLink,
  };
};
